// URL path <-> screen name mapping
export const PATH_TO_SCREEN = {
  '/': 'feed', '/leit': 'search', '/nyttvert': 'newjob', '/dagatal': 'calendar',
  '/minsida': 'mypage', '/bilstjori': 'driver', '/stjornbord': 'admin',
  '/ragga': 'ragga', '/skilmalar': 'terms',
};

export const SCREEN_TO_PATH = Object.fromEntries(
  Object.entries(PATH_TO_SCREEN).map(([k, v]) => [v, k])
);

// Dynamic routes: /verk/:id, /spjall/:id, /notandi/:id
export function screenFromPath(pathname) {
  if (pathname.startsWith('/verk/')) return { screen: 'job', id: pathname.slice(6) };
  if (pathname.startsWith('/spjall/')) return { screen: 'chat', id: pathname.slice(8) };
  if (pathname.startsWith('/notandi/')) return { screen: 'profile', id: pathname.slice(9) };
  return { screen: PATH_TO_SCREEN[pathname] || 'feed', id: null };
}

export function pathForScreen(screen, id) {
  if (screen === 'job' && id) return '/verk/' + id;
  if (screen === 'chat' && id) return '/spjall/' + id;
  if (screen === 'profile' && id) return '/notandi/' + id;
  return SCREEN_TO_PATH[screen] || '/';
}
